module.exports = new __parcel__URL__("wbtvd-logo.60fb8cdc.png").toString();